import summary from '../data/directory-summary.json';

// Access layer for the full MOEY directory (1,654 institutions).
//
// The dataset is ~508KB — about 12x the rest of the school JSON combined, on a
// bundle already flagged oversized — so it is NOT imported. It ships as a
// static asset and is fetched the first time a page actually needs a listing.
// Counts come from `directory-summary.json` (821 bytes) instead, so headline
// figures render immediately without pulling the full file.

export const directorySummary = summary;
export const TOTAL_INSTITUTIONS = summary.total;
export const LEVEL_COUNTS = summary.byLevel;
export const PARISHES = summary.parishes;

const URL = '/data/schools-directory.json';

let cache = null;
let inflight = null;

/** Fetch (once) and cache the full directory. Returns []. on failure. */
export function loadDirectory() {
  if (cache) return Promise.resolve(cache);
  if (inflight) return inflight;

  inflight = fetch(URL)
    .then((res) => {
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
      return res.json();
    })
    .then((json) => {
      cache = Array.isArray(json?.data) ? json.data : [];
      return cache;
    })
    .catch((err) => {
      // A failed directory fetch must not take a page down — callers render an
      // error state and the summary counts above still work.
      console.error('[schoolDirectory] could not load directory:', err.message);
      cache = [];
      return cache;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

/**
 * Filter the directory. All criteria are optional and combine with AND.
 *   levels  – array of level names ('Primary', 'Early Childhood', …)
 *   type    – exact MOEY school type ('Infant', 'All Age', 'Technical High', …)
 *   parish  – exact parish name
 *   sector  – 'Public' | 'Independent'
 *   search  – matched against name, address and parish, case-insensitive
 */
export function filterSchools(schools, { levels, type, parish, sector, search } = {}) {
  const q = (search || '').trim().toLowerCase();
  return schools.filter((s) => {
    if (levels && levels.length && !levels.includes(s.level)) return false;
    if (type && s.type !== type) return false;
    if (parish && s.parish !== parish) return false;
    if (sector && s.sector !== sector) return false;
    if (q) {
      const hay = `${s.name} ${s.address} ${s.parish}`.toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  });
}

/** Count institutions across a set of levels, from the bundled summary. */
export function countLevels(levels) {
  return levels.reduce((n, l) => n + (summary.byLevel[l] || 0), 0);
}

export default loadDirectory;
